import React from 'react'

function StudyAbroad() {
  return (
    <div>
      <h1>Study a broad</h1>
    </div>
  )
}

export default StudyAbroad